import axios from 'axios';
import i18n from '@/i18n';
import { dayjs } from '@/plugins/dayjs';

export default {
  baseURL: process.env.BASE_URL + 'api/surveys',

  SurveyInstanceStatus: {
    New: 100,
    ShopperStarted: 110,
    ShopperCompleted: 120,
    QueryWaitingForShopper: 130,
    QueryShopperCompleted: 140,
    ReadyToSubmit: 145,
    QueryMSM: 150,
    ReadyToSubmitQueryMSM: 155,
    AgencyCompletedSurvey: 160,
    AgencyCompletedQuery: 165,
    InternalReview: 170,
    Hidden: 190,
    Ok: 200,
    Processing: 215,
    Released: 220,
    Deleted: 300,
    DeletedShopper: 301,
    DeletedAgency: 302,
    DeletedInternal: 303,
    DeletedExternal: 304,
    InternalUse: 400,
    Delete: 900
  },

  getSurveyStructure(localizationId, cxFilter, surveysWithoutInstances) {
    return axios.get('structure',
      {
        baseURL: this.baseURL,
        params: {
          'localization-id': localizationId || i18n.global.locale,
          'cxfilter': cxFilter || null,
          'surveys-without-instances': surveysWithoutInstances
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyTargetGroups(surveyIds) {
    return axios.post('target-groups',
      {
        'survey-ids': (surveyIds && _.size(surveyIds) > 0) ? surveyIds.join() : null,
      },
      {
        baseURL: this.baseURL
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyWaves(filter, localizationId) {
    return axios.get('waves',
      {
        baseURL: this.baseURL,
        params: {
          'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
          'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
          'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
          'localization-id': localizationId || i18n.global.locale
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyCustomProperties(filter, withValues, onlyHasSurveyInstances, onlyVisible, onlyWithExplicitPermissions, cancelToken) {
    return axios.post('custom-properties',
      {
        'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
        'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'wave-ids': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'with-values': withValues,
        'only-has-survey-instances': onlyHasSurveyInstances,
        'only-visible': onlyVisible,
        'only-with-explicit-permissions': onlyWithExplicitPermissions
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      }
      )
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyKpis(filter, localizationId) {
    return axios.get('kpis',
      {
        baseURL: this.baseURL,
        params: {
          'survey-ids': filter.surveyIds.join(),
          'localization-id': localizationId || i18n.global.locale
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyKpisWithIds(filter, localizationId) {
    return axios.get('kpiIds',
      {
        baseURL: this.baseURL,
        params: {
          'survey-ids': filter.surveyIds.join(),
          'localization-id': localizationId || i18n.global.locale
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyQuestions(surveyIds, includeComments, localizationId) {
    return axios.post('questions',
      {
        'survey-ids': (surveyIds && _.size(surveyIds) > 0) ? surveyIds.join() : null,
        'include-comments': includeComments,
        'localization-id': localizationId || i18n.global.locale
      },
      {
        baseURL: this.baseURL
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyUploads(filter, localizationId) {
    return axios.get('uploads',
      {
        baseURL: this.baseURL,
        params: {
          'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
          'localization-id': localizationId || i18n.global.locale
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyProofUploads(filter, localizationId) {
    return axios.get('proofs',
      {
        baseURL: this.baseURL,
        params: {
          'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
          'localization-id': localizationId || i18n.global.locale
        }
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        console.log(error);
      });
  },

  getSurveyUploadProofFiles(surveyInstanceIds, surveyProofIds, downloadProgressCallback, cancelToken) {
    return axios.post('upload-proof-files', {
        'SurveyInstanceIds': surveyInstanceIds,
        'SurveyProofIds': surveyProofIds,
        'LocalizationId': i18n.global.locale
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null,
        onDownloadProgress: downloadProgressCallback
      })
      .then(function (response) {
        return response;
      });
  },

  getSurveyUploadFiles(surveyInstanceIds, surveyQuestionIds, downloadProgressCallback, cancelToken) {
    return axios.post('upload-files', {
        'SurveyInstanceIds': surveyInstanceIds,
        'SurveyQuestionIds': surveyQuestionIds,
        'LocalizationId': i18n.global.locale
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null,
        onDownloadProgress: downloadProgressCallback
      })
      .then(function (response) {
        return response;
      });
  },

  getSurveyUploadFile(surveyInstanceIds, surveyQuestionIds) {
    return axios.post('upload-file', {
        'SurveyInstanceIds': surveyInstanceIds,
        'SurveyQuestionIds': surveyQuestionIds
      },
      {
        baseURL: this.baseURL,
        responseType: 'blob'
      })
      .then(function (response) {
        return response;
      });
  },

  getSurveyScenarios(filter, localizationId) {
    return axios.get('scenarios',
    {
      baseURL: this.baseURL,
      params: {
        'client-ids': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'project-ids': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
        'survey-ids': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'localization-id': localizationId || i18n.global.locale
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      console.log(error);
    });
  },

  getSurveyInstances(filter, options, cancelToken) {
    return axios.post('', {
        'PageSize': options ? options.pageSize : null,
        'Page': options ? options.page : null,
        'ClientIds': (filter && _.size(filter.clientIds) > 0) ? filter.clientIds.join() : null,
        'ProjectIds': (filter && _.size(filter.projectIds) > 0) ? filter.projectIds.join() : null,
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : null,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : null,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : null,
        'DatePeriods': (filter && _.size(filter.datePeriods) > 0) ? filter.datePeriods.join() : null,
        "DateFrom": filter?.dateFrom ? dayjs(filter?.dateFrom).format('YYYY-MM-DD') : null,
        "DateTo": filter?.dateTo ? dayjs(filter?.dateTo).format('YYYY-MM-DD') : null,
        'PropertyIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : null,
        'PropertyIdsUseLogicalAnd': options ? options.propertyUseLogicalAnd : null,
        'ClientLocationIds': (filter && _.size(filter.locationIds) > 0) ? filter.locationIds.join() : null,
        'SearchText': (filter && filter.searchText) ? filter.searchText : null,
        'ColumnFilter': (filter && _.size(filter.columnFilter) > 0) ? JSON.stringify(filter.columnFilter) : null,
        'SortBy': (filter && filter.sortBy) ? filter.sortBy : null,
        'SortDescending': (filter && filter.sortDescending) ? filter.sortDescending : null,
        'WithUploads': (filter && filter.withUploads) ? filter.withUploads : null,
        'UploadQuestionIds': (filter && _.size(filter.uploadQuestionIds) > 0) ? filter.uploadQuestionIds.join() : null,
        'WithRevisions': (filter && filter.withRevisions) ? filter.withRevisions : null,
        'OnlyHasRevisions': (filter && filter.onlyHasRevisions) ? filter.onlyHasRevisions : null,
        'WithImprovements': (filter && filter.withImprovements) ? filter.withImprovements : null,
        'OnlyHasImprovements': (filter && filter.onlyHasImprovements) ? filter.onlyHasImprovements : null,
        'OnlyUnreleased': (filter && filter.onlyUnreleased) ? filter.onlyUnreleased : null,
        'OnlyUnread': (filter && filter.onlyUnread) ? filter.onlyUnread : null,
        'LocalizationId': (options && options.localizationId) ? options.localizationId : i18n.global.locale,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }

        return Promise.reject(error);
      });
  },

  setSurveyInstanceReleasedState(surveyInstanceIds) {
    return axios
      .put(`survey-instance/released-state`,
      {
        'SurveyInstanceIds': surveyInstanceIds
      },
      {
        baseURL: this.baseURL
      });
  },

  postSurveyInstanceReadByUser(surveyInstanceId) {
    return axios.post('survey-instance-read-by-user',
      surveyInstanceId,
    {
      baseURL: this.baseURL,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(function (response) {
      return response;
    })
    .catch(function (error) {
      if (!axios.isCancel(error)) {
        console.error(error);
      }
      return Promise.reject(error);
    });
  },

  getSurveyKpiAssignments(surveyId, cancelToken) {
    return axios.get('kpi-assignments',
      {
        baseURL: this.baseURL,
        params: {
          'surveyId': surveyId
        },
        cancelToken: cancelToken ? cancelToken.token : null
      });
  },

  setSurveyKpiCustomAssignments(surveyId, data) {
    return axios.put('kpi-custom-assignments', data,
      {
        baseURL: this.baseURL,
        params: {
          'surveyId': surveyId
        }
      });
  },

  getSurveyInstanceCount(filter, options, cancelToken) {
    return axios.post('survey-instance-count', {
        'SurveyIds': (filter && _.size(filter.surveyIds) > 0) ? filter.surveyIds.join() : undefined,
        'WaveIds': (filter && _.size(filter.waveIds) > 0) ? filter.waveIds.join() : undefined,
        'ScenarioIds': (filter && _.size(filter.scenarioIds) > 0) ? filter.scenarioIds.join() : undefined,
        'ClientLocationIds': (filter && _.size(filter.clientLocationIds) > 0) ? filter.clientLocationIds.join() : undefined,
        'CustomPropertyValueIds': (filter && _.size(filter.propertyIds) > 0) ? filter.propertyIds.join('|') : undefined,
        'CustomPropertyUseLogicalAnd': filter ? filter.propertyUseLogicalAnd : undefined,
        'SurveyInstanceStatusIdMinimum': filter ? filter.surveyInstanceStatusIdMinimum : undefined,
        'SurveyInstanceStatusIdMaximum': filter ? filter.surveyInstanceStatusIdMaximum : undefined,
        'IncludeTestchecks': filter ? filter.includeTestchecks : undefined,
        'Caller': options ? options.caller : undefined,
      },
      {
        baseURL: this.baseURL,
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      });
  },
};
